module.exports = __webpack_public_path__ + "static/media/menu_mobile.56077f6d.svg";